"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "specialsByRetailerId", {
    enumerable: true,
    get: ()=>specialsByRetailerId
});
const _graphqlRequest = require("graphql-request");
const _specialFragment = require("../fragments/special-fragment");
const specialsByRetailerId = (0, _graphqlRequest.gql)`
    query specialsByRetailerId($retailerId: ID!) {
        specials(retailerId: $retailerId) {
            ...specialFragment
        }
    }
    ${_specialFragment.SPECIAL_FRAGMENT} 
`;
